function normalizePinCode(pinCode: string): string {
    return (pinCode ?? "").trim();
}

function normalizeInput(userId: number, pinCode: string): string {
    return `${userId}:${normalizePinCode(pinCode)}`;
}

export async function hashQualityHubPinCodeAsync(
    userId: number,
    pinCode: string,
): Promise<string> {
    const normalizedInput = normalizeInput(userId, pinCode);
    const data = new TextEncoder().encode(normalizedInput);

    const digest = await crypto.subtle.digest("SHA-256", data);
    return Array
        .from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
}
